import React from "react";
import PropTypes from "prop-types";

import ChargingStationCard from "../ChargingStationCard/ChargingStationCard";
import ShowHideButton from "../../ShowHideButton/ShowHideButton";

import { useIntl } from "react-intl";

import "./ChargingStationsList.scss";

const ChargingStationsList = ({ chargingStations }) => {
  const intl = useIntl();

  return (
    <div className="ChargingStationsList">
      <ShowHideButton
        buttonText={
          intl.formatMessage
            ? intl.formatMessage({
                id: "chargingMapnew.showFullListOfStations",
                defaultMessage: "full list of stations",
              })
            : "full list of stations"
        }
      >
        <div className="charging-station-cards-container">
          <div className="row">
            <div className="col-sm-6 offset-sm-3 cardContainer">
              {chargingStations.map((station, i) => {
                return (
                  <ChargingStationCard
                    key={station.id}
                    chargingStation={station}
                    style={{
                      margin: "0 12px 20px 12px",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      width: "285px",
                      height: "137px",
                      alignItems: "center",
                      padding: "24px 16px",
                      borderRadius: "0px",
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </ShowHideButton>
    </div>
  );
};

ChargingStationsList.propTypes = {
  chargingStations: PropTypes.array,
};

ChargingStationsList.defaultProps = {
  chargingStations: [],
};

export default ChargingStationsList;
